import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	configEnabledAndNoFailureLogsMainText: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.logs-table.no-records.config-enabled-and-no-failure-logs-main-text',
		defaultMessage: 'All set! Customer notifications for your project went through successfully!',
		description: 'Title about the feature being unavailable for users not under evaluation',
	},
});
